import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import patientReducer from "./reducers/patientReducer";
import masterDataReducer from "./reducers/masterDataReducer";
import deviceReducer from "./reducers/deviceReducer";
import careTeamReducer from "./reducers/careTeamReducer";
import patientVitalThresholdReducer from "./reducers/patientVitalThresholdReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    patient: patientReducer,
    masterData: masterDataReducer,
    device: deviceReducer,
    careTeam: careTeamReducer,
    patientVitalThreshold: patientVitalThresholdReducer,
  },
});